import React from 'react';
import PropTypes from 'prop-types';

const NavLinkCollection = ({
  children,
}) => (
  <div className="menu-top-menu-container">
    <ul id="menu-top-menu" className="clearfix">
      {children}
    </ul>
  </div>
);

NavLinkCollection.propTypes = {
  children: PropTypes.node,
};

NavLinkCollection.defaultProps = {
  children: undefined,
};

export default NavLinkCollection;
